"use client";

import React, { useEffect, useState } from "react";
import { m as motion } from "framer-motion";

export const FloatingParticles = React.memo(() => {
  const [particles, setParticles] = useState<
    Array<{ id: number; x: number; y: number; delay: number }>
  >([]);

  useEffect(() => {
    const newParticles = Array.from({ length: 3 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      delay: i * 0.2,
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          initial={{ x: `${particle.x}%`, y: `${particle.y}%`, opacity: 0 }}
          animate={{
            x: `${particle.x + (Math.random() - 0.5) * 30}%`,
            y: `${particle.y + (Math.random() - 0.5) * 30}%`,
            opacity: [0, 0.5, 0],
          }}
          transition={{
            duration: 8 + Math.random() * 4,
            repeat: Infinity,
            delay: particle.delay,
            ease: "easeInOut",
          }}
          className="absolute w-1 h-1 rounded-full bg-primary/30 blur-sm"
        />
      ))}
    </div>
  );
});

FloatingParticles.displayName = "FloatingParticles";
